import CustomUndoBtn from 'components/tool/Editor/ButtonDiv/UndoButton';
import { KonvaGroupNames } from 'components/tool/utils';
import { useRefDispatch, useRefs } from 'contexts/RefContext';
import Konva from 'konva';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import { undoLastObstruction } from 'store/slices/ObstructionUndoSlice';
import { setDrawnObsExists } from 'store/slices/ToolSlice';

export default function UndoButton() {

	//------------------NOTE: OLD LOGIC OF UNDO ADD OBTRCUTION, REMOVE IT ONCE NEW UNDO IS FINE------------------// 
	// const { konvaRef } = useRefs();
	// const [undoEnabled, setUndoEnabled] = useState<boolean>(false);
	// const {open: debugDialogOpen} = useSelector((state: RootState) => state.debugDialog.data);
	// const refDispatch = useRefDispatch();

	// useEffect(() => {
	// 	const stage = konvaRef?.current;
	// 	if (!stage) return;
	// 	const obsDrawerGroup = stage.findOne(`.${KonvaGroupNames.obstructionDrawingGroup}`) as Konva.Group;
	// 	if (!obsDrawerGroup) return;
		
	// 	const handleAdd = () => {
	// 		const isDrawing = (obsDrawerGroup?.children?.length || 0) > 0;
	// 		setUndoEnabled(isDrawing);
	// 	};
	// 	obsDrawerGroup.on('add', handleAdd);
		
	// 	return () => {
	// 		obsDrawerGroup.off('add', handleAdd);
	// 	};
	// }, [konvaRef]);

	// const undoAddObstruction = useCallback(() => {
	// 	if (!konvaRef?.current) return;

	// 	const obsDrawerGroup = konvaRef.current.findOne(`.${KonvaGroupNames.obstructionDrawingGroup}`) as Konva.Group;
	// 	if (!obsDrawerGroup?.hasChildren()) return;

	// 	const allInProcessObsGroups = obsDrawerGroup.find(`.${KonvaGroupNames.inProgressUserDefinedObsGroup}`) as Konva.Group[];
	// 	if (!allInProcessObsGroups.length) return;

	// 	const recentGroup = allInProcessObsGroups[allInProcessObsGroups.length -1] as Konva.Group;
	// 	if (!recentGroup.children?.length) return;

	// 	const children = recentGroup.children;
	// 	// determine the shape
	// 	if(children.length == 1){
	// 		// removing the circle obs
	// 		const circleObs = recentGroup.findOne('.obs-circle') as Konva.Circle;
	// 		if(!circleObs?.getAttr('completed')){
	// 			console.log('resetting refs');
	// 			refDispatch({ type: 'RESET_DRAWN_OBS_REF', payload: { ref: null as any } });
	// 		}
	// 		dispatch(removeNewlyCreatedObs({ id: getObsIDFromGroupID(children[0].id()) }));
	// 		recentGroup.destroy();
	// 	}
	// 	else{
	// 		// removing the rect obs
	// 		const rectVertices = recentGroup.find('.obs-rect-vertex-circle') as Konva.Circle[];
	// 		if (rectVertices.length){
	// 			const rectObs = recentGroup.findOne('.obs-rectangle') as Konva.Rect;
	// 			if(!rectObs?.getAttr('completed')){
	// 				console.log('resetting refs');
	// 				refDispatch({ type: 'RESET_DRAWN_OBS_REF', payload: { ref: null as any } });
	// 			}
	// 			dispatch(removeNewlyCreatedObs({ id: getObsIDFromGroupID(children[0].id()) }));
	// 			recentGroup.destroy();
	// 		}
	// 		else{
	// 			// removing the polygon obs
	// 			const polygonVertices = recentGroup.find('.obs-polygon-vertex-handle') as Konva.Circle[];
	// 			const previewLine = recentGroup.findOne('.obs-preview-line') as Konva.Line;
	// 			previewLine?.points([]);
	// 			const polygonObsLine = children[0] as Konva.Line;
	// 			if (polygonObsLine) {
	// 				if (polygonObsLine?.closed()) {
	// 					dispatch(removeNewlyCreatedObs({ id: getObsIDFromGroupID(polygonObsLine.id()) }));
	// 					recentGroup.destroy();
	// 				}
		
	// 				const points = polygonObsLine.points();
	// 				if(points.length === 2){
	// 					console.log('resetting refs');
	// 					refDispatch({type: 'RESET_DRAWN_OBS_REF', payload: { ref: null as any }});
	// 				}
	// 				if (points.length >= 2) {
	// 					console.log('deleting lines');
	// 					points.splice(-2);
	// 					polygonVertices.pop()?.destroy();
	// 					polygonObsLine.points(points);
	// 					polygonObsLine.closed(false);
	// 				} 
		
	// 				if(!points.length) {
	// 					console.log('deleting points');
	// 					recentGroup.destroy();
	// 				}
	// 			}
	// 		}
	// 	}
	// 	const hasChildren = (obsDrawerGroup?.children?.length || 0) > 0;
	// 	setUndoEnabled(hasChildren);
	// },[dispatch, konvaRef, refDispatch]);

	// useEffect(() => {
	// 	const handleKeyDown = (event: KeyboardEvent) => {
	// 		if (event.ctrlKey && event.key === 'z') {
	// 			undoAddObstruction();
	// 		}
	// 	};
	// 	if(!debugDialogOpen){
	// 		document.addEventListener('keydown', handleKeyDown);
	// 	}
	// 	return () => document.removeEventListener('keydown', handleKeyDown);
	// }, [undoAddObstruction, debugDialogOpen]);

	// if (!undoEnabled) return null;

	// return (
	// 	<CustomUndoBtn
	// 		id="undo-add-obstruction"
	// 		onClick={undoAddObstruction}
	// 	/>
	// );
	//--------------------------------------------------------------------------------// 
	const dispatch = useDispatch<AppDispatch>();
	const { konvaRef } = useRefs();
	const refDispatch = useRefDispatch();

	const undoStack = useSelector(
		(state: RootState) => state.obstructionState.stack
	);

	const [undoEnabled, setUndoEnabled] = useState(false);

	const getStageAndDrawerGroup = useCallback(() => {
		const stage = konvaRef?.current;
		if (!stage) return { stage: null, obsDrawerGroup: null };

		const obsDrawerGroup = stage.findOne(
			`.${KonvaGroupNames.obstructionDrawingGroup}`
		) as Konva.Group | null;

		return { stage, obsDrawerGroup };
	}, [konvaRef]);

	const hasInProgressGroups = (obsDrawerGroup: Konva.Group | null) => {
		if (!obsDrawerGroup) return false;
		return (
			obsDrawerGroup.find(
				`.${KonvaGroupNames.inProgressUserDefinedObsGroup}`
			).length > 0
		);
	};

	useEffect(() => {
		const { stage, obsDrawerGroup } = getStageAndDrawerGroup();
		if (!stage || !obsDrawerGroup) return;

		const updateUndoState = () => {
			const hasInProgress = hasInProgressGroups(obsDrawerGroup);
			setUndoEnabled(hasInProgress || undoStack.length > 0);
		};

		updateUndoState();
		obsDrawerGroup.on('add remove', updateUndoState);

		return () => {
			obsDrawerGroup.off('add remove', updateUndoState);
		};
	}, [getStageAndDrawerGroup, konvaRef, undoStack.length]);

	const undoInProgress = useCallback((): boolean => {
		const { stage, obsDrawerGroup } = getStageAndDrawerGroup();
		if (!stage || !obsDrawerGroup?.hasChildren()) return false;

		const allInProcessObsGroups = obsDrawerGroup.find(`.${KonvaGroupNames.inProgressUserDefinedObsGroup}`) as Konva.Group[];
		if (!allInProcessObsGroups.length) return false;

		const recentGroup = allInProcessObsGroups[allInProcessObsGroups.length - 1];
		if (!recentGroup.children?.length) return false;

		const rect = recentGroup.findOne('.obs-rectangle') as Konva.Rect | null;
		const circle = recentGroup.findOne('.obs-circle') as Konva.Circle | null;
		const line = recentGroup.findOne('.obs-line') as Konva.Line | null;

		/* ---------------- Circle / Rectangle ---------------- */
		if (
			(rect && !rect.getAttr('completed')) ||
      (circle && !circle.getAttr('completed'))
		) {
			refDispatch({
				type: 'RESET_DRAWN_OBS_REF',
				payload: { ref: null },
			});

			recentGroup.destroy();
			stage.batchDraw();
			return true;
		}

		/* ---------------- Polygon ---------------- */
		if (line) {
			const points = line.points();
			const vertices = recentGroup.find('.obs-polygon-vertex-handle') as Konva.Circle[];
			const previewLine = recentGroup.findOne('.obs-preview-line') as Konva.Line;
			previewLine?.points([]);

			// Closed polygon -> return false
			if (line.closed()) {
				return false;
			}

			// Remove last edge
			if (points.length >= 2) {
				points.splice(-2);
				vertices.pop()?.destroy();
				line.points(points);
				line.closed(false);

				if (points.length === 0) {
					recentGroup.destroy();
					refDispatch({
						type: 'RESET_DRAWN_OBS_REF',
						payload: { ref: null },
					});
				}

				stage.batchDraw();
				return true;
			}
		}

		return false;
	}, [getStageAndDrawerGroup, refDispatch]);

	const handleUndo = useCallback(() => {
		// undoing in-progress canvas state
		const didUndoCanvas = undoInProgress();
		if (didUndoCanvas) {
			const { obsDrawerGroup } = getStageAndDrawerGroup();
			if (!hasInProgressGroups(obsDrawerGroup)) {
				dispatch(setDrawnObsExists({ exists: false }));
				setUndoEnabled(false);
			}
			return;
		}

		dispatch(undoLastObstruction());
	}, [dispatch, getStageAndDrawerGroup, undoInProgress]);

	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			if (event.ctrlKey && event.key === 'z') {
				handleUndo();
			}
		};

		document.addEventListener('keydown', handleKeyDown);

		return () => {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [handleUndo]);

	if (!undoEnabled) return null;

	return (
		<CustomUndoBtn
			id="undo-obstruction"
			onClick={handleUndo}
		/>
	);
}